<template>
    <div id="ticketViwer">
        <div class="row">
            <div class="col-12 p-4">
                <div class="text-center mb-4 betcheck">
                    <a href="/">
                        PAYMENTCHECK
                    </a>
                </div>
            </div>
            <div class="col-12 p-4">
                <table class="table">
            <tbody v-if="bet">
                <tr :class="bet.status">
                <th>{{ t.status }}:</th>
                <td>
                    {{ bet.status }}
                </td>
                </tr>
                <tr>
                <th>{{ t.betting.title.date }}:</th>
                <td>
                    {{ bet.added_date | moment('D.M.Y HH:mm', session.timezone)}}
                </td>
                </tr>
                <tr>
                    <th>{{ t.amount }}:</th>
                    <td>{{ bet.amount | toMoney(bet.currency) }}</td>
                </tr>
                <tr>
                    <th>Shop ID:</th>
                    <td>{{ bet.reseller }}</td>
                </tr>
            </tbody>
            </table>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import cashoutButton from "@/components/sportsbook/widget/cashoutButton";
    import betDetail from '@/components/user/account/betDetail'
    export default {
            name: 'ticketViewer',
            components: {betDetail, cashoutButton},
            data () {
                return {
                    betid: 0,
                    bet: null,
                    t: this.$root.t,
                    session: window.session,
                    hostname: window.location.hostname
                }
            },
            mounted () {
                this.betid = parseInt(this.$route.params.id)
                this.pin = parseInt(this.$route.query.pin)
                this.fetchBets()
            },
            methods: {
                async fetchBets() {
                this.$http.get(api + 'api/v1/payment-slip/' + this.betid)
                    .then(response => {
                        this.bet = response.body;
                    }, response => {
                        this.notfound = 1;
                    })
                },
            }
        }
    </script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
    .betcheck {
        font-size: 24px;
        font-weight: bold;
        position: relative;
    }
    .operator {
        position: relative;
        bottom: 30px;
        left: 30px;
        font-size: 16px;
    }
    #ticketViwer {
        position: absolute;
        width: 100vw;
        height: 100vh;
        background-color:rgb(237, 237, 237);
        top: 0;
        left: 0;
        z-index: 1000;
        overflow-y: scroll;
    }
    #ticketViwer > .row {
        max-width: 600px;
        margin: auto;
    }
    table {
        background-color: #fff;
        box-shadow: 0 0 2px 0 rgba(var(--black-box-shadow-rgb), .14), 0 1px 3px 0 rgba(var(--black-box-shadow-rgb), .14);
    }
    table th {
        font-weight: bold;
    }
    .cashout-box {
        opacity: 0.7;
        pointer-events: none;
    }
    .cashout-label {
        font-size: 22px
    }
    .Processed {
        background-color: greenyellow;
    }
    .Pending {
        background-color: blueviolet;
        color: white;
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/pages/PaymentSlipViewer.vue